class QueryStringModel {
    private params: {[name: string]: string} = {};

    public hasParam(param: string): boolean {
        return this.params.hasOwnProperty(param);
    }

    public getParam(param: string): string {
        return this.params[param];
    }

    public parse(): void {
        this.params = {};
        const url = window.location.href;
        if (url.indexOf('?') === -1) return;
        const split = url.split('?');
        const pairs = split[1].split('&');
        pairs.forEach(pair => {
            const s = pair.split('=');
            this.params[s[0]] = s[1];
        });
    }
}

export default new QueryStringModel();



// WEBPACK FOOTER //
// ./src/queryString/QueryStringModel.ts